import { deepMerge } from 'js/utils/Utils'
import { gsap } from 'gsap'

import { getTargetOffsetTop, pauseTween } from 'js/utils/Utils'
import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'scrollAnchor',
  $name: {
    trigger: '[data-scroll-anchor]',
  },
  dataName: {
    destination: 'scrollAnchor',
    adjuster: 'scrollAnchorAdjuster',
  },
  scrollToInfo: {
    duration: 0.8,
    easing: 'cubic.inOut',
  },
}

export default class ScrollAnchor {
  constructor(options = {}) {
    this.$contentRoot = document
    this.$trigegrAll = []

    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this.addEventListeners()
  }

  destroy() {
    this.removeEventListeners()
  }

  _set$() {
    if (this.$contentRoot) {
      this.$trigegrAll = this.$contentRoot.querySelectorAll(this.$name.trigger)
    }
  }

  addEventListeners() {
    this.$trigegrAll.forEach(($trigger) => {
      $trigger.addEventListener('click', this.onClick, {})
    })
  }

  removeEventListeners() {
    this.$trigegrAll.forEach(($trigger) => {
      $trigger.removeEventListener('click', this.onClick, {})
    })
  }

  onClick = (e) => {
    if (!e) return

    e.preventDefault()
    const $trigger = e.currentTarget

    this.anchorReady($trigger)
  }

  anchorReady($trigger) {
    if (!$trigger) return

    const data = $trigger.dataset
    if (!data) return

    const cancel = $trigger.dataset['anchorCancel']

    if (cancel !== null && cancel !== undefined && cancel !== 'false') {
      return
    }

    const destination = data[this.dataName.destination]
    const offsetAdjuster = data[this.dataName.adjuster] || 0

    this.anchor(destination, offsetAdjuster)
  }

  anchor(destination, offsetAdjuster) {
    let offset = 0

    console.log(destination)

    if (destination instanceof HTMLElement) {
      offset = getTargetOffsetTop(destination)
    } else if (typeof destination == 'string') {
      const limit = document.body.clientHeight - window.innerHeight

      if (destination === 'top') {
        offset = 0
      } else if (destination === 'bottom') {
        offset = limit
      } else if (destination === 'second-view') {
        offset = window.innerHeight
      } else if (destination === 'next-view') {
        offset = Math.min(limit, Common.scroll.currentScroll + window.innerHeight)
      } else {
        const $target = document.querySelectorAll(destination)[0]
        if ($target && $target instanceof HTMLElement) {
          offset = getTargetOffsetTop($target)
        }
      }
    }

    if (parseInt(offsetAdjuster) && typeof parseInt(offsetAdjuster) === 'number') {
      offsetAdjuster = parseInt(offsetAdjuster)
    } else {
      if (offsetAdjuster) {
        const $offsetAdjuster = document.querySelector(offsetAdjuster)[0]
        if ($offsetAdjuster) {
          offsetAdjuster = -$offsetAdjuster.clientHeight || 0
        } else {
          offsetAdjuster = 0
        }
      } else {
        offsetAdjuster = 0
      }
    }

    if (Common.scroll) {
      const offsetObj = {
        easeOffset: Common.scroll.currentScroll,
      }

      offset += offsetAdjuster
      pauseTween(this.anchorTweem)

      this.anchorTweem = gsap.to(offsetObj, {
        easeOffset: offset,
        duration: this.scrollToInfo.duration,
        ease: this.scrollToInfo.easing,
        onUpdate: () => {
          Common.scroll.manager.scrollTo(offsetObj.easeOffset, { immediate: false })
        },
      })
    } else {
      gsap.to([document.documentElement, document.body], {
        scrollTop: offset,
        duration: this.scrollToInfo.duration,
        ease: this.scrollToInfo.easing,
      })
    }
  }
}